import moment from 'moment'
import axios from 'axios'

export const authorizedRequest = (url) => {
  const accessToken = localStorage.getItem('accessToken')
  const expiresAt = localStorage.getItem('expiresAt')
  const currentTime = moment()
  return url === 'devices/login' || (!!accessToken && currentTime.isBefore(moment(expiresAt)))
}

export const CancelToken = axios.CancelToken
